import React from 'react';

export default function OnboardingHints({ userId, onDismiss }: { userId: string; onDismiss: () => void }) {
  function gotIt() {
    try {
      localStorage.setItem(`auralink-onboard-dismissed:${userId}`, 'true');
      localStorage.removeItem(`auralink-onboard-eligible:${userId}`);
    } catch {}
    onDismiss();
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50" role="dialog" aria-modal="true">
      <div className="themed-card rounded-2xl p-6 w-[92%] max-w-xl">
        <h3 className="text-2xl font-bold mb-2">Welcome to TeaKonn</h3>
        <p className="text-theme-secondary mb-4">Here are a few quick tips to get started:</p>
        <ul className="space-y-2 text-sm text-theme-secondary">
          <li>• Discover events on the Discover page and join or create your own.</li>
          <li>• Use Messages to chat in real-time and coordinate with others.</li>
          <li>• List services or products to connect with the community.</li>
          <li>• Update your profile and status to let people know you’re available.</li>
        </ul>
        <div className="mt-6 flex justify-end">
          <button className="btn px-4 py-2 rounded-lg" onClick={gotIt} aria-label="Dismiss onboarding hints">Got it</button>
        </div>
      </div>
    </div>
  );
}
